import { useLingui } from "@lingui/react/macro";
import { TriangleAlert } from "lucide-react";
import { cn } from "@/lib/utils";

interface CcpStepPrintNoteProps {
  /** The step's instruction, printed as the details under the step. */
  text: string;
  className?: string;
}

/**
 * What a critical-control-point step prints under itself: the icon, the words
 * "Critical control point" and the step's instruction. Paper has no popup to
 * tap, and a colour-only mark would vanish on a black-and-white printer, so the
 * meaning is carried by the icon's shape and the words, in the page's ink.
 * Hidden on screen, where `CcpStepFlag` is.
 */
export function CcpStepPrintNote({ text, className }: CcpStepPrintNoteProps) {
  const { t } = useLingui();
  return (
    <p
      data-testid="ccp-print-note"
      className={cn(
        "hidden items-start gap-1.5 border-l-2 border-current pl-2 text-(--color-text-primary) print:flex print:text-[8.5pt]",
        className,
      )}
    >
      <TriangleAlert className="mt-0.5 size-3.5 shrink-0 print:size-3" aria-hidden />
      <span>
        <b>{t`Critical control point`}</b>
        {text ? `: ${text}` : ""}
      </span>
    </p>
  );
}
